import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const networking = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setNetworkings(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedNetworkings(state, payload) {
            state.selectedItems = payload;
        },
        setNetworkingPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getNetworkings');
        },
        setNetworkingTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getNetworkings');
        },
    },
    actions: {
        async saveNetworkingOrder(context, payload) {
            var res = await axios.post('/NetworkingArea/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async getNetworkings(store) {
            store.state.loading = true;
            await axios
                .post('networkingarea/list', {
                    ...store.state.filter,
                    skip: (store.state.filter.page - 1) * store.state.filter.take,
                })
                .then((res) => {
                    store.state.loading = false;
                    return store.commit('setNetworkings', res.data.data);
                });
        },
        async toggleNetworking(store, payload) {
            var res = await axios.post('networkingarea/toggleisactive', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res.data;
        },
        async getNetworking(store, payload) {
            var res = await axios.post('networkingarea/get', { id: payload });
            return res;
        },
        async addUpdateNeworking(store, payload) {
            var res = await axios.post('networkingarea/addorupdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async deleteNetworking(store, payload) {
            var res = await axios.post('networkingarea/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default networking;


// WEBPACK FOOTER //
// ./src/store/networking.js